const store = {
    namespaced: true,
    state() {
        return {
            compare: {
                showNotification: false,
                showModal: false,
                removed: false,
                products: []
            }
        };
    },
    getters: {
        getCompareProducts(state) {
            return state.compare.products;
        },
        getCompareProductsLength(state) {
            return state.compare.products.length;
        },
        getIsRemoved(state) {
            return state.compare.removed;
        },
        getCompareCategory(state) {
            return state.compare.products.length && state.compare.products[0].category
                ? state.compare.products[0].category[0]
                : null;
        },
        getCompareCategoryList(state) {
            return state.compare.products.reduce((unique, product) => {
                const productInfo = {
                    title: product.category[0]?.subcategoryTitle,
                    id: product.category[0]?.subcategoryId
                };

                if (!unique.some(obj => obj.id === productInfo.id)) {
                    unique.push(productInfo);
                }

                return unique;
            }, []);
        },
        getIsShowNotification(state) {
            return state.compare.showNotification;
        },
        getIsShowModal(state) {
            return state.compare.showModal;
        },
        isTheSameCategory(state) {
            let categories = state.compare.products.map(e => {
                return e.category[0].subcategoryUrl;
            });
            const allEqual = arr => arr.every(v => v === arr[0]);

            return allEqual(categories);
        }
    },
    mutations: {
        removeProductFromCompareShop(state, productId) {
            let isInCompare = state.compare.products.findIndex(e => e.productId === productId);
            if (isInCompare !== -1) {
                state.compare.products = state.compare.products.filter(p => p.productId !== productId);
                localStorage.setItem('compare', JSON.stringify(state.compare.products));
            }
            if (!state.compare.products.length) {
                localStorage.removeItem('compare');
            }
        },

        setProductToCompare(state, product) {
            let isInCompare = false;
            const productId = parseFloat(product.productId);
            state.compare.products.find(el => {
                if (parseFloat(el.productId) === productId) isInCompare = true;
            });

            if (isInCompare) {
                state.compare.products = state.compare.products.filter(el => parseFloat(el.productId) !== productId);
            } else {
                state.compare.products.push(product);
            }

            this.$cookies.set('compare', JSON.stringify(state.compare.products));
            localStorage.setItem('compare', JSON.stringify(state.compare.products));
        },
        setRemoved(state, value) {
            state.compare.removed = value;
        },
        setIsShowNotification(state, value) {
            state.compare.showNotification = value;
        },
        setIsShowModal(state, value) {
            state.compare.showModal = value;
        },

        initCompareProducts(state, products) {
            state.compare.products = products;
        }
    },
    actions: {
        addProductToCompare(context, product) {
            context.commit('setProductToCompare', product);
            context.commit('setIsShowNotification', true);

            setTimeout(() => {
                context.commit('setIsShowNotification', false);
            }, 1000);
        },
        removeProductToCompare(context, product) {
            context.commit('setProductToCompare', product);
            context.commit('setRemoved', true);
            context.commit('setIsShowNotification', true);

            setTimeout(() => {
                context.commit('setIsShowNotification', false);
                context.commit('setRemoved', false);
            }, 1000);
        }
    }
};

export default store;
